module.exports = __webpack_public_path__ + "img/revisao.37037881.jpg";